import React from 'react';
import MainPriorAuth from './MainPriorAuth';

function PriorAuth() {
  return <MainPriorAuth />;
}

export default PriorAuth;
